import { useSearchParams } from 'react-router-dom';

export const RETURN_TO_PARAM = 'returnTo';

/**
 * Reads the `?returnTo=` intent set by an onboarding gate so a prerequisite form
 * can send the user back to what they were doing after saving.
 *
 * Only same-origin absolute paths are honored (must start with a single "/"),
 * so the param can never be used to redirect off-site (open redirect).
 */
export const useReturnTo = (): string | null => {
  const [params] = useSearchParams();
  const raw = params.get(RETURN_TO_PARAM);
  if (raw && raw.startsWith('/') && !raw.startsWith('//')) {
    return raw;
  }
  return null;
};
